import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26692e07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","width":"100%","align-items":"center"} }
const _hoisted_2 = {
  key: 0,
  style: {"margin-right":"10px"}
}
const _hoisted_3 = { style: {"flex":"none"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_show_area = _resolveComponent("ui-show-area")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue && _ctx.modelValue.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ui_show_area, { modelValue: _ctx.modelValue }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _ctx.chooseArea,
        underline: false
      }, {
        default: _withCtx(() => [
          _createTextVNode("选择区域")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}